const defaultState = () => ({
  cities: [],
  citiesFilter: {
    text: null
  },
  selectedCity: null
});

export default defaultState;
